import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=7468a11c&scoped=true&"
import script from "./Duration.vue?vue&type=script&lang=js&"
export * from "./Duration.vue?vue&type=script&lang=js&"
import style0 from "./Duration.vue?vue&type=style&index=0&id=7468a11c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7468a11c",
  null
  
)

export default component.exports